import { NeutralColors } from '@fluentui/react';

export const getBudgetCenterMonthPickerStyle = (_components, { palette }) => ({
  monthPickerContainer: {
    marginLeft: 'auto',
    marginRight: 16,
  },
  monthPickerSection: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  monthPickerButton: {
    width: 172,
    padding: '0px 4px',
    borderColor: NeutralColors.gray80,
  },
  monthPickerButtonText: {
    display: 'flex',
    alignItems: 'center',
    color: palette.neutralSecondary,
    fontWeight: 400,
  },
  monthText: {
    fontSize: 14,
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 130,
  },
  calendarIcon: {
    fontSize: 16,
    lineHeight: '16px',
    marginLeft: 'auto',
    top: 0,
  },
  navigationIcons: {
    fontSize: 12,
    lineHeight: '12px',
    color: palette.neutralSecondary,
    '& button:not([disabled]):hover': {
      backgroundColor: palette.neutralLight,
    },
    '& button[disabled]': {
      color: palette.neutralTertiaryAlt,
    },
  },
  navigationIconButtonWrapper: {
    background: 'none',
    border: 'none',
    padding: 0,
  },
  navigationIcon: {
    padding: 8,
    top: 0,
  },
  monthPickerCallout: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
    backgroundColor: palette.white,
    '& .year-components .navContainer': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 12,
    },
    '& .isSelected': {
      backgroundColor: `${palette.themePrimary} !important`,
      color: palette.white,
    },
  },
});
